'use es6';

let _ = t => t,
  _t,
  _t2;
import { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../theming/themes/colors';
import websitePerformanceRating from 'bender-url!../../../img/website-performance-rating.jpg';
import { TabletAndBelow } from '../../theming/themes/mixins';
import { WEB_FONT_FAMILY } from 'HubStyleTokens/misc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAccordion = styled.div.withConfig({
  displayName: "BottomFaq__StyledAccordion",
  componentId: "hhajes-0"
})(["border:1px solid ", ";margin-bottom:1.2rem;.question{line-height:20px;margin-bottom:0;position:relative;font-family:", ";font-size:1.1rem;font-weight:600;cursor:pointer;padding:1.75rem 1.75rem 1.75rem 3rem;}.question::before{transform:", ";border-style:solid;border-width:1px 1px 0 0;content:' ';display:inline-block;position:absolute;top:45%;left:1.5rem;transition:0.25s ease-in-out;vertical-align:top;width:10px;height:10px;}.answer{display:", ";font-size:0.875rem;font-weight:300;line-height:1.75;padding:0 3.5rem 2rem;}"], colors.LIGHTGREYBORDER, WEB_FONT_FAMILY, props => props.open ? 'rotate(135deg)' : 'rotate(45deg)', props => props.open ? 'inline-block' : 'none');
const BottomFaqWrapper = styled.div.withConfig({
  displayName: "BottomFaq__BottomFaqWrapper",
  componentId: "hhajes-1"
})(["background-color:", ";color:", ";width:100%;text-align:start;font-family:", ";"], colors.PRIMARYWHITE, colors.DARKTEXT, WEB_FONT_FAMILY);
const OverviewSection = styled.section.withConfig({
  displayName: "BottomFaq__OverviewSection",
  componentId: "hhajes-2"
})(["margin:5rem auto;max-width:1000px;display:flex;flex-direction:row;justify-content:space-around;padding:0 1rem;.overview{width:45%;}h2.overview-title{font-family:", ";font-size:2rem;font-weight:600;line-height:1.38;letter-spacing:0;text-transform:none;text-align:start;padding:1rem 0;}p.overview-description{font-size:1rem;font-weight:300;line-height:1.75;padding:1.5rem 0;}.overview-img{width:45%;img{height:auto;width:100%;}}", ""], WEB_FONT_FAMILY, TabletAndBelow(_t || (_t = _`
    flex-direction: column-reverse;

    .overview {
      width: 100%;
    }

    .overview-img {
      height: auto;
      width: 100%;
    }
  `)));
const QuestionsSection = styled.section.withConfig({
  displayName: "BottomFaq__QuestionsSection",
  componentId: "hhajes-3"
})(["background-color:", ";padding:3rem 0;.questions-center-wrapper{max-width:1000px;margin:0 auto;h2.questions-title{font-family:", ";font-size:1.625rem;font-weight:600;letter-spacing:0;text-transform:none;padding-bottom:1rem;}.questions{display:flex;flex-wrap:wrap;justify-content:space-around;}.questions-col{width:48%;padding:0 1rem;", "}}"], colors.MEDIUMGREYBACKGROUND, WEB_FONT_FAMILY, TabletAndBelow(_t2 || (_t2 = _`
        width: 100%;
      `)));
const Accordion = ({
  question,
  answer
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = e => {
    e.stopPropagation();
    setOpen(!open);
  };
  return /*#__PURE__*/_jsxs(StyledAccordion, {
    open: open,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("h3", {
      className: "question",
      children: question
    }), /*#__PURE__*/_jsx("article", {
      className: "answer",
      children: answer
    })]
  });
};
const BottomFaq = () => {
  return /*#__PURE__*/_jsxs(BottomFaqWrapper, {
    children: [/*#__PURE__*/_jsxs(OverviewSection, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "overview",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "overview-title",
          children: "Get Your Website Rating in Seconds"
        }), /*#__PURE__*/_jsx("p", {
          className: "overview-description",
          children: "HubSpot's free website grader makes understanding website performance easy. The hardest part of building a site is often the guesswork. Which changes are important, and which aren\u2019t? It can sometimes feel impossible to tell. Our online grader demystifies the whole process. Learn about your page performance, security, search engine optimization (SEO), and mobile experience. Discover what makes your site strong and uncover new opportunities for the future."
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "overview-img",
        children: /*#__PURE__*/_jsx("img", {
          loading: "lazy",
          height: "462px",
          width: "470px",
          src: websitePerformanceRating,
          alt: "Webpage score after performing a free test with the Website Grader"
        })
      })]
    }), /*#__PURE__*/_jsx(QuestionsSection, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "questions-center-wrapper",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "questions-title",
          children: "More Information"
        }), /*#__PURE__*/_jsxs("div", {
          className: "questions",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "questions-col",
            children: [/*#__PURE__*/_jsx(Accordion, {
              question: "What is a website checker?",
              answer: /*#__PURE__*/_jsxs("p", {
                children: ["A website checker is a mini site audit, giving you insight into how your website performs. A good website analyzer should audit your site across a range of criteria so you can get an idea of your overall performance, security, mobile experience, and search engine optimization (SEO). If you\u2019re looking for next steps, read", /*#__PURE__*/_jsx("a", {
                  className: "p-x-1",
                  target: "blank",
                  href: "https://academy.hubspot.com/courses/web-optimization\\",
                  children: "HubSpot\u2019s Academy Course on Web Optimization"
                }), "to learn about the factors that are both improving and reducing your site rating."]
              })
            }), /*#__PURE__*/_jsx(Accordion, {
              question: "Why is website performance important?",
              answer: "Performance test matters because it is a key factor in user experience. When users get an immediate response, such as a click, a successful login, or confirmation, they are more likely to stay on the page. This fast response is commonly referred to as website speed. Search engines like Google check website speed and interactivity to make sure searchers only see high-quality sites. So beyond building a better user experience, speed tools help you make your site more attractive to search engines \u2013 win-win."
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "questions-col",
            children: [/*#__PURE__*/_jsx(Accordion, {
              question: "How to optimize a website for SEO?",
              answer: "There are some concrete steps you can take to optimize your site for SEO. Making sure your pages are indexed (viewable by search engines) is a great start. In addition, making full use of alt-tags and meta-data is advised. If you want to go further, try making sure you have descriptive link text and appropriate content plugins. And if you\u2019re wondering where to start, getting your site's SEO score is a great first step. It just so happens HubSpot's website grader has a built-in SEO test!"
            }), /*#__PURE__*/_jsx(Accordion, {
              question: "Why is website grading important?",
              answer: "Test grading is important because it can help you build your site smarter and better while monitoring its health along the way. These site testers help show the impact of the steps you\u2019re taking and areas for new opportunities by checking the pages of your website. It can also help you understand what your competitors are doing, and why they do it. Technical evaluation and general assessment are important in any site build. Doing both makes your site successful in the search results and beyond!"
            })]
          })]
        })]
      })
    })]
  });
};
export default BottomFaq;